export class InsertNotificationDTO {
  title: string = '';
  body: string = '';
  type:string = '';
}
